import moment from "moment";

/**
 * Function Validator Date
 * @param {int} value
 */
export function maskDate(value) {
  return moment.unix(value).format("DD/MM/YYYY");
}
